angular.module('zc.core')
  .filter('byteFormat', byteFormat);

byteFormat.$inject = [];
function byteFormat() {
  return function(bytes, precision) {
    let units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
    let number = Math.floor(Math.log(bytes) / Math.log(1024));

    if(isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
    if(angular.isUndefined(precision)) precision = 1;
    return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/byte_format.filter.js